<template>
  <nav>
    <h2>Allotments</h2>
    <menu>
      <NavLink to="/allotments" :notifications="rejectionsCount ?? undefined" label="Overview" icon="list" tooltip="Allotments Overview"/>
    </menu>
  </nav>
</template>
<script lang="ts">
import {mapState} from 'pinia';

import NavLink from '@/components/structure/NavLink.vue';
import {useAllotmentsStore} from "@/Features/Allotments/stores/allotment-store.ts";

export default {
  components: {
    NavLink,
  },
  data: function () {
    return {isPaxDataAllowed: false}
  },
  computed: {
    ...mapState(useAllotmentsStore, {
      rejectionsCount: 'rejectionsCount',
    }),
  },
};
</script>
